import React from 'react';
import Helmet from "react-helmet";
import {Card, CardGroup, Row, Col} from 'react-bootstrap';
import { Container } from 'reactstrap';
import { Link } from 'react-router-dom';

import speaker from "../../assets/images/contents/DrEisukeKita.jpg"

export const ProfDrEisukeKita = () => (
  <div>
    <Helmet>
      <title>The 7th International Conference on Soft Computing in Data Science 2022 (scds2023) - Keynote Speaker</title>
    </Helmet>
    <nav aria-label="breadcrumb" style={{ padding: '0.5rem'}}>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link to="/scds2023/home">Home</Link></li>
        <li class="breadcrumb-item active" aria-current="page">Prof Dr Eisuke Kita</li>
      </ol>
    </nav>

    <Container> 
      <Row className="justify-content-md-center">  
        <Col md="auto">
          <Card>
            <Card.Img width="100px" height="220px" src={speaker} alt="speaker image" /> 
          </Card>             
        </Col>
      </Row>
    </Container>

    <p style={{textAlign:'center'}}>
      <b>Prof Dr Eisuke Kita</b>
    </p>

    <p style={{textAlign:'center'}}>
        Institute of Liberal Arts and Sciences, Nagoya University, Japan
    </p>

    <br/>

    <h4 style={{textAlign:'center'}}>Application of Data Science in Agriculture</h4>

    <p style={{ textAlign:'justify'}}><b>Abstract</b><br/>
      Machine Learning (ML) models are often determined by relying on knowledge and experience. In recent years, many automatic building methods are proposed, but there are some 
      problems related to accuracy, computation cost, and explainability. The speech will include the use of Stochastic Schemata Exploiter-Based AutoML and its modification of the 
      Stochastic Schemata Exploiter algorithm. A genetic representation of the stacking model and optimize the stacking model using SSE and the visualization of the process of SSE.
    </p>

    <p style={{ textAlign:'justify'}}><b>Biography</b><br/>
        Eisuke Kita was born in Japan in 1964. He moved straight from high school to the School of Engineering of Mie University. After getting the bachelor and the master degree, 
        he moved to Graduate School of Mechanical Engineering of the Nagoya University and graduated with the Doctor of Engineering in 1991. He spent 9 years in the School of Mechanical 
        Engineering as a lecturer and an assistant professor, and 11 years in the School of Informatics and Science as an associate professor. He became, in 2009, the full professor 
        of the Graduate School of Information Science of the Nagoya University. His publications include numerical analysis schemes, application of Bayesian network and  
    </p>

    <p style={{ textAlign:'justify'}}>Click this <b><a href = "https://profs.provost.nagoya-u.ac.jp/html/100001819_en.html" target="_blank">link</a></b> to see his further detail bio.<br/></p>

  </div>
)